import * as _ from 'lodash';
import React from 'react';

import { useFieldBulletinBoardEdit } from '../../services/fieldBulletinBoard/FieldBulletinBoardEditContext';

import DeleteIcon from '../../images/icon/icon--delete-7.svg';
import { Confirmation, Information } from '../modals/common';
import { Button } from '@bld/bld-libs/components';

import { messageUtility } from '../../utilities/messageUtility';

/**
 * 現場掲示板
 * @returns { JSX.Element }
 */
export function FieldBulletinBoardDeleteButton() {
  const {
    closeConfirmDialog,
    getModalDisplayInfo,
    handleDeleteButtonClick,
    handleDeleteCompleteModalCloseButtonClick,
    handleDeleteConfirmModalConfirmButtonClick,
  } = useFieldBulletinBoardEdit();

  const modalDisplayInfo = getModalDisplayInfo();

  return (
    <React.Fragment>
      <Button
        color='error'
        onClick={() => {
          handleDeleteButtonClick();
        }}
        startIcon={<img src={DeleteIcon} />}
        sx={{
          backgroundColor: '#FFFFFF',
          minWidth: '100px',
          width: '100%',
        }}
        variant='outlined'
      >
        {messageUtility.getMessage('I-000-167-05')}
      </Button>
      {/* 削除確認 */}
      <Confirmation
        cancelButtonText={messageUtility.getMessage('I-000-008')}
        confirmButtonText={messageUtility.getMessage('I-000-167-10')}
        isNegative
        message={messageUtility.getMessage('I-000-167-09')}
        multilineText={true}
        onCancel={() => {
          closeConfirmDialog();
        }}
        onConfirm={() => handleDeleteConfirmModalConfirmButtonClick()}
        title={messageUtility.getMessage('I-000-167-08')}
        visible={_.has(modalDisplayInfo, 'delete') && modalDisplayInfo.delete}
      />
      {/* 削除完了 */}
      <Information
        visible={
          _.has(modalDisplayInfo, 'deleteComplete') &&
          modalDisplayInfo.deleteComplete
        }
        title={messageUtility.getMessage('I-000-167-06')}
        message={messageUtility.getMessage('I-000-167-07')}
        onClose={() => handleDeleteCompleteModalCloseButtonClick()}
        buttonText={messageUtility.getMessage('I-000-017')}
      />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/fieldBulletinBoard/FieldBulletinBoardDeleteButton.jsx